// eslint-disable-next-line
import * as React from 'react';
import './BpiViewPageHeader.css';
import { BpiCategory } from '../../../entities/BpiEntities';

type Props = {
    categories: BpiCategory[];
}

type State = {

}

// ------------------------------------------------------------------------------------------------
// component

class BpiViewPageHeader extends React.Component<Props, State> {

    // --------------------------------------------------------------------------------------------
    // render

    public render() {
        return (
            <div className='bpi-view-page-header'>
                <h1>Building Product Information</h1>
                <p>Please select from the following product categories:</p>

                <div className='bpi-view-page-header-nav'>
                    <h3>

                        {this.props.categories.map((category: BpiCategory, index) => {
                            return (
                                <React.Fragment key={category.code}>
                                    {index !== 0 && <span> | </span>}
                                    <a href={`/bpi#${category.code}`}>
                                        {category.label}
                                    </a>
                                </React.Fragment>
                            )
                        })}

                    </h3>
                </div>

            </div>
        )
    }
};



export default BpiViewPageHeader;